import {
  PaginationData,
  PaginationRequestFnType,
  useEventBus,
  usePagination,
} from '@byted/hooks';
import { Pagination } from '@douyinfe/semi-ui';
import { useEffect } from 'react';
import { CommentItem } from './Post/CommentItem';
import { Reply } from '@/typings/open.platform.forum_bff/namespaces/forum';
import { forumPostService } from '@/api/forumPost';
import useBiz from '@/context/useBiz';
import useComment from '@/context/useComment';

type Props = {
  commentId: string;
};
export const ReplyList: React.FC<Props> = ({ commentId, ...reset }: Props) => {
  const biz = useBiz(state => state.biz);
  const fetcher: PaginationRequestFnType<PaginationData<Reply>> = async ({
    current,
    pageSize,
  }) => {
    const res = await forumPostService.getReplyList({
      PageNo: current,
      PageSize: pageSize,
      Uid: '',
      Biz: biz,
      CommentId: commentId,
    });
    if (res.error) {
      return {
        total: 0,
        list: [],
      };
    } else {
      return {
        total: Number(res.data.Total),
        list: res.data.Replies || [],
      };
    }
  };
  const {
    data: replyList,
    pagination,
    reset: reFetchReply,
  } = usePagination(fetcher, {
    refreshDeps: [commentId],
    ready: Boolean(commentId),
    defaultPageSize: 10,
  });

  useEffect(() => {
    useComment.setState({ reFetchReply });
  }, [reset]);

  useEventBus('RELOAD_REPLY', (id: string) => {
    if (id === commentId) {
      reFetchReply();
    }
  });

  return (
    <div {...reset} className={'space-y-2'}>
      {replyList?.list.map(reply => (
        <CommentItem content={reply} key={reply.Id} />
      ))}
      {pagination.total > 10 && <Pagination {...pagination} />}
    </div>
  );
};
